<template>
<div id="app" class="site container hfeed">
  <HeadNav selectedLanguage="en" page="privacy" />

  <div id="content" class="site-content">
    <article class="privacy-article">
      <section class="privacy-content">
        <header class="privacy-header">
          <hh1>Privacy Policy</hh1>
        </header>

        <p>
          At <strong>GBWAOnline</strong>, the <strong>privacy of our visitors</strong> is one of our top priorities. This Privacy Policy document describes the types of information that are collected and recorded by GBWAOnline and how we use it.
        </p>

        <section class="section">
          <hh2>1. Information We Collect</hh2>
          <p>
            GBWAOnline does not collect any <strong>personally identifiable information (PII)</strong> unless voluntarily provided by visitors (for example, through a contact form or email).
          </p>
          <p>
            We may automatically collect <strong>non-personal data</strong>, such as:
          </p>
          <ul>
            <li>Browser type and version</li>
            <li>Referring and exit pages</li>
            <li>Date and time of visit</li>
            <li>General location (city/country)</li>
          </ul>
        </section>

        <section class="section">
          <hh2>2. How We Use Your Information</hh2>
          <p>
            We may use collected data to:
          </p>
          <ul>
            <li>Improve the user experience</li>
            <li>Analyze website traffic and performance</li>
            <li>Respond to inquiries and feedback</li>
          </ul>
          <p>
            We do not <strong>sell, trade, or rent</strong> users' personal identification information to others.
          </p>
        </section>

        <section class="section">
          <hh2>3. Cookies</hh2>
          <p>
            Like most websites, GBWAOnline uses "cookies" to store information about visitors' preferences and to optimize page performance. Visitors can choose to disable cookies through their browser settings.
          </p>
        </section>

        <section class="section">
          <hh2>4. Consent</hh2>
          <p>
            By using our website, you hereby consent to our <strong>Privacy Policy</strong> and agree to its terms.
          </p>
        </section>

      </section>
    </article>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Privacy',
  components: { HeadNav },
};
</script>

<style scoped>
.privacy-article {
  display: block;
}

.privacy-content {
  max-width: 900px;
  margin: 2rem auto;
  padding: 24px;
  background: #fff;
  border-radius: 16px;
}

.privacy-header {
  text-align: center;
  margin-bottom: 24px;
}

.section {
  margin: 24px 0;
}

.section p {
  line-height: 1.7;
  color: #495057;
  font-size: 1.1em;
  margin: 16px 0;
}

.section ul {
  line-height: 1.7;
  color: #495057;
  font-size: 1.1em;
  margin: 16px 0;
  padding-left: 30px;
}

.section ul li {
  margin: 8px 0;
}

@media (max-width: 768px) {
  .privacy-content {
    padding: 16px;
    margin: 1rem auto;
  }

}
</style>
